import {CustomerLight, CustomerSystem} from "../Types/customer";

export const isClientCIS = (customer?: CustomerLight) => {
  // return false;
  if (!customer) {
    return false;
  }

  return customer.system === CustomerSystem.CIS;
}

export const isDivopClient = (clientType?: string | null) => clientType?.toLowerCase() === 'divop';
